import {useRouter} from 'next/router';
import {MouseEvent, SyntheticEvent, useCallback} from 'react';
import {t} from '../../common/getTranslations';
import {REFETCH_INVEN_EVENT_NAME} from '../../domain/inven/[invenType]/constant';
import {ExceptionMobileHeaderType} from '../../header/constants';
import {LOG_CLICK_EVENT} from '../../logging/logEvent';
import {putTiaraObjectProps} from '../../logging/putTiaraObjectProps';
import {NewWindowHeader} from '../organisms/NewWindowHeader/NewWindowHeader';

interface MobileLayoutNewWindowHeaderProps {
  headerType:
    | ExceptionMobileHeaderType.NewWindow
    | ExceptionMobileHeaderType.NewWindowTwoDepth;
  headerTitle?: string;
  closeWindowText?: string;
  onClickBack: (e: SyntheticEvent) => void;
  historyBack: () => void;
}

export function MobileLayoutNewWindowHeader({
  headerType,
  headerTitle = '',
  closeWindowText = t('common_close_button'),
  onClickBack,
  historyBack,
}: MobileLayoutNewWindowHeaderProps) {
  const router = useRouter();
  const onClickClose = useCallback(
    (e: MouseEvent) => {
      LOG_CLICK_EVENT(
        isInvenEditPage(location.pathname) ? '취소_클릭' : '팝업_닫기_클릭',
        e,
        () => {
          if (window.opener) {
            if (isInvenEditPage(location.pathname)) {
              const refetchEvent = new Event(REFETCH_INVEN_EVENT_NAME);
              window.opener.dispatchEvent(refetchEvent);
            }
            window.close();
          } else {
            historyBack();
          }
        }
      );
    },
    [historyBack]
  );

  return (
    <NewWindowHeader
      headerType={headerType}
      title={headerTitle}
      onClickClose={onClickClose}
      onClickBack={onClickBack}
      closeText={closeWindowText}
      {...putTiaraObjectProps({
        customProps: {
          ...(router.query.commentUid
            ? {event_comment_id: String(router.query.commentUid)}
            : {}),
          ...(router.query.productId
            ? {event_episode_id: String(router.query.productId)}
            : {}),
        },
      })}
    />
  );
}

function isInvenEditPage(path: string) {
  const regex = new RegExp(/\/inven\/[a-zA-Z]+\/edit/);
  return regex.test(path);
}
